<form [formGroup]="filterForm" (ngSubmit)="getNewInvoices()">
  <mat-form-field appearance="fill">
    <mat-select formControlName="month" name="month">
      @for (month of months | keyvalue; track month) {
        <mat-option
          [value]="month.key"
          >
          {{ month.value }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Year</mat-label>
    <input formControlName="year" matInput (keypress)="keyPressNumbers($event)" />
  </mat-form-field>
  <button mat-raised-button color="primary" class="ml-4" type="submit">
    View Invoices for Selected Month
  </button>
  <button mat-raised-button (click)="openUpdateInvoiceDialog()" color="warn" style="float: right;" class="mt-4 mr-5" type="button">
    Update Invoice's
  </button>
  @if (generatingInvoices) {
    <mat-progress-bar style="height: 4px; width: 100%;" mode="indeterminate"></mat-progress-bar>
  }
</form>

@if (loadingInvoices) {
  <mat-progress-bar
    mode="indeterminate"
  ></mat-progress-bar>
}
<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="Name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let consolidatedInvoice">
      {{ consolidatedInvoice.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Business Name">
    <th mat-header-cell *matHeaderCellDef>Business Name</th>
    <td mat-cell *matCellDef="let consolidatedInvoice">
      {{ consolidatedInvoice.businessName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Email Address">
    <th mat-header-cell *matHeaderCellDef>Email Address</th>
    <td mat-cell *matCellDef="let consolidatedInvoice">
      {{ consolidatedInvoice.emailAddress }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Phone Number">
    <th mat-header-cell *matHeaderCellDef>Phone Number</th>
    <td mat-cell *matCellDef="let consolidatedInvoice">
      {{ consolidatedInvoice.primaryPhoneNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Total Bill">
    <th mat-header-cell *matHeaderCellDef>Total Bill</th>
    <td mat-cell *matCellDef="let consolidatedInvoice">
      ${{ consolidatedInvoice.totalOwedForMonth.toFixed(2)  }}
    </td>
  </ng-container>

  <ng-container matColumnDef="Amount Paid">
    <th mat-header-cell *matHeaderCellDef>Amount Paid</th>
    <td mat-cell *matCellDef="let consolidatedInvoice">
      @if (consolidatedInvoice.amountPaid) {
        <div>${{ consolidatedInvoice.amountPaid.toFixed(2) }}</div>
      }
      @if (!consolidatedInvoice.amountPaid) {
        <div>$0.00</div>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="Amount Still Owed">
    <th mat-header-cell *matHeaderCellDef>Amount Owed</th>
    <td mat-cell *matCellDef="let consolidatedInvoice">
      ${{

      consolidatedInvoice.amountOwed
      }}
    </td>
  </ng-container>

  <ng-container matColumnDef="View Invoices">
    <th mat-header-cell *matHeaderCellDef>Pay Invoices</th>

    <td mat-cell *matCellDef="let consolidatedInvoice">
      <mat-icon
        class="clickable"
        (click)="openDetailsDialog(consolidatedInvoice.invoices)"
        >launch</mat-icon
        >
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
